import React, { useState } from 'react';
import Button from '../misc/Button';
export default function ExportJsonPanel(_a) {
    var graph = _a.graph, save = _a.save;
    var _b = useState('graph.json'), name = _b[0], setName = _b[1];
    var _c = useState(false), minify = _c[0], setMinify = _c[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "field" },
            React.createElement("label", { className: "label" }, "File name"),
            React.createElement("div", { className: "control" }),
            React.createElement("input", { className: "input", type: "text", placeholder: "e.g. graph.json", value: name, onChange: function (e) { return setName(e.target.value); } })),
        React.createElement("div", null,
            React.createElement("label", { className: "checkbox" },
                React.createElement("input", { type: "checkbox", className: "checkbox", checked: minify, onChange: function (e) { return setMinify(e.target.checked); } }),
                "\u00A0Minify the downloaded JSON file?")),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("div", null,
            React.createElement(Button, { onClick: function () { return save(graph, { name: name, format: 'json', minify: minify }); }, color: "black" }, "Download"))));
}
